import { Switch, Route, Link, Redirect } from 'react-router-dom'
import { Icon } from '@aider/ui'

import { LoadingContainer } from '@components/'

import SelectImportOption from './SelectImportOption'
import SelectImportTransactions from './SelectImportTransactions'

const ImportLayout = () => (
  <LoadingContainer>
    <header className="sticky z-10 top-0 flex items-center py-4 h-20 bg-white space-x-3">
      <Link
        to="/huvudman/redovisning/transaktioner"
        className="text-blue-500 text-2xl font-medium hover:opacity-50 transition-opacity"
      >
        ...
      </Link>
      <Icon
        name="chevron-right"
        className="flex-shrink-0 w-2.5 h-2.5 text-black fill-current"
      />
      <div className="text-2xl font-medium">Importera transaktioner</div>
    </header>
    <div className="px-12 space-y-3">
      <p>
        Hämta de transaktioner som ska bokföras, genom att importera dem från
        banken via fil eller BankID. För mer information om hur du genomför en
        import, läs här:{' '}
        <a
          href="https://intercom.help/aider/sv/articles/5633822-hur-far-jag-in-transaktioner-i-aider"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 font-medium hover:underline"
        >
          Hur får jag in transaktioner i Aider?
        </a>
      </p>
      <p>
        För mer information om vilket fil-format du ska välja när du skapar en
        fil, läs här:{' '}
        <a
          href="https://intercom.help/aider/sv/articles/5626811-hur-skapar-jag-en-import-fil-pa-banken"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 font-medium hover:underline"
        >
          Hur skapar jag en import-fil?
        </a>
      </p>
    </div>
    <Switch>
      <Route
        exact
        path="/huvudman/redovisning/transaktioner/importera"
        component={SelectImportOption}
      />
      <Route
        exact
        path="/huvudman/redovisning/transaktioner/importera/:importId"
        component={SelectImportTransactions}
      />
      <Route
        render={() => (
          <Redirect to="/huvudman/redovisning/transaktioner/importera" />
        )}
      />
    </Switch>
  </LoadingContainer>
)

export default ImportLayout
